<template>
  <div class="list-bg" >
    <div class="content" :class="{selected: selectedId === itemObj.hotspot_id}">
      <span class="type" v-if="itemObj.type">{{listType[itemObj.type]}}</span>
      <span class="list-name" v-if="itemObj.title">{{itemObj.title}}</span>

      <a-dropdown>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="0">{{$t('actionTitles.edit')}}</a-menu-item>
          <a-menu-item key="1">{{$t('actionTitles.rename')}}</a-menu-item>
          <a-menu-item key="2">{{$t('actionTitles.delete')}}</a-menu-item>
        </a-menu>
        <a-button>
          {{$t('edit.options')}}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemObj: {
      required: true,
      type: Object,
    },
    selectedId: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      listType: {
        word: "T",
        pictext: this.$t('edit.typeList.picture'),
        pic: this.$t('edit.typeList.picture'),
        video: this.$t('edit.typeList.video'),
        audio: this.$t('edit.typeList.audio'),
        link: this.$t('edit.typeList.link'),
        scene: this.$t('edit.typeList.scene'),
      },
    };
  },
  methods: {
    handleMenuClick({ item, key }) {
      if (key === "0") {
        this.$emit("editItem", this.itemObj);
      } else if (key === "1") {
        this.$emit("renameItem", this.itemObj);
      } else if (key === "2") {
        this.$emit("deleteItem", this.itemObj);
      }
    },
  },
};
</script>